var __rspack_ns_object = {"rE":"0.7.0"}